import * as React from "react";
import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import generalPOST from "../../services/generalPOST";
import Navbar from "../../components/layout/Navbar";

/**
 * React component for resetting user password.
 * @returns {JSX.Element}
 * @constructor
 */
const ResetPassword = () => {
    const [newPassword, setNewPassword] = useState("");
    const [params] = new URLSearchParams(useLocation().search);
    const [payload, setPayload] = useState("");
    const history = useHistory();

    const HandleSubmit = async (event) => {
        event.preventDefault();
        let promise;
        let response;

        promise = generalPOST(`${process.env.REACT_APP_API_URL}/api/reset_password`, { password: newPassword, token: params[0] });

        promise
            .then((res) => {
                response = res;
                return res.text();
            })
            .then((data) => {
                if (response.status === 200 || response.status === 400) {
                    setPayload(data);
                }
            })
            .catch((err) => {
                switch (err.name) {
                    case "AbortError":
                        console.log("post aborted");
                        break;
                    default:
                        break;
                }
            });
    };

    return (
        <div className="min-h-screen bg-sage font-body pt-16">
            
            <Navbar />

            <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] p-4">
                <div className="w-full md:max-w-md bg-offwhite md:shadow-lg md:rounded-lg overflow-hidden">
                
                {/* Form Section */}
                <div className="w-full bg-offwhite flex items-center justify-center">
                    <div className="w-full max-w-md px-6 py-8">
                        <div className="flex flex-col items-center">
                            {/* Lock Icon */}
                            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-forest mb-4">
                                <svg className="w-6 h-6 text-offwhite" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                            </div>
                            
                            <h1 className="text-2xl font-heading font-semibold text-charcoal mb-6">
                                Ändra lösenord
                            </h1>
                            
                            <div className="w-full">
                                <div className="mb-4">
                                    <label htmlFor="password" className="block text-sm font-medium text-charcoal mb-1">
                                        Nytt lösenord *
                                    </label>
                                    <input
                                        type="password"
                                        id="password"
                                        name="password"
                                        required
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        className="w-full px-3 py-2 border border-sage rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-forest focus:border-forest bg-white"
                                    />
                                </div>

                                {payload && (
                                    <div className="my-4 p-4 bg-sage rounded-md">
                                        <p className="text-center text-charcoal">{payload}</p>
                                    </div>
                                )}

                                <button
                                    type="button"
                                    onClick={() => history.push("/SignIn")}
                                    className="w-full bg-leaf text-offwhite py-2 px-4 rounded-md hover:bg-forest transition-colors duration-200 mb-2 font-medium"
                                >
                                    Tillbaka
                                </button>

                                {!payload && (
                                    <button
                                        type="submit"
                                        onClick={(e) => HandleSubmit(e)}
                                        className="w-full bg-leaf text-offwhite py-2 px-4 rounded-md hover:bg-forest transition-colors duration-200 mb-2 font-medium"
                                    >
                                        Ändra
                                    </button>
                                )}

                                {/* Footer */}
                                <div className="mt-8 pt-8 text-center w-full border-t border-sage">
                                    <p className="text-sm text-brown">
                                        &copy; {new Date().getFullYear()} Naturborgarmärket
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

export default ResetPassword;
